import { ThemeProvider } from "@material-ui/core/styles";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SaveAlt from "@mui/icons-material/SaveAlt";
import { addDays, differenceInDays, format } from "date-fns";
import { ContextMenu } from "primereact/contextmenu";
import { Paginator } from "primereact/paginator";
import React, { Fragment, useEffect, useRef } from "react";
import { AuthContext } from "../../App";
import {
    containerDownloadImg,
    containerDownloadJpeg,
    containerDownloadJson,
    containerDownloadTiff,
    containerDownloadXml,
    containerLaudo,
    postListarcontainerDownloadXls,
    postListarContainers
} from "../../services/ContainerService";
import { Pagina } from "../template/Template";

import DateFnsUtils from "@date-io/date-fns";
import { Button, IconButton } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import ptBR2 from "date-fns/locale/pt-BR";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { Formik } from "formik";
import { Loading } from "../Loading";

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import { Dialog } from "primereact/dialog";
import { containerImagewithmarks } from "../../services/ContainerService";
import { ShowMessageBox } from "../ShowMessageBox";
import {
    CirculoStatus,
    CirculoVeredito
} from "../status/Circulos";

import DeveloperBoard from "@material-ui/icons/DeveloperBoard";
import download from "js-file-download";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Tooltip from "@material-ui/core/Tooltip";
import { clienteFindAllByUsuId } from "../../services/ClienteService";

import { useStyles } from "../styles/StyleListarcontainer";
import { theme } from "../styles/Theme";

var MS_PER_DAY = 60000 * 60 * 24;

let severity = "success";
let msg = "";

export default function Listarcontainer() {
    const classes = useStyles();
    const cm = useRef(null);
    const { state: authState } = React.useContext(AuthContext);
    const DIAS_LIMIT = 7;
    const DIAS_LIMIT_MAX = 365;


    const Content = () => {
        const [openSnackBar, setOpenSnackBar] = React.useState(false);
        const [openImageView, setOpenImageView] = React.useState(false);
        const [selectionItem, setSelectionItem] = React.useState(null);

        const menuModel = [
            {
                label: "Visualizar XML",
                icon: "pi pi-twitter",
                command: async () => {
                    if (selectionItem) {
                        for (let i = 0; i < selectionItem.length; i++) {
                            await downloadXml(selectionItem[i].trk_id, selectionItem[i].con_container);
                        }
                        setSelectionItem(null);
                    }
                },
            },
            {
                label: "Visualizar Marcas",
                icon: "pi pi-tablet",
                command: () => {
                    if (selectionItem) {
                        if (selectionItem.length > 1) {
                            severity = "info";
                            msg = "Selecione apenas um container para visualizar as marcas";
                            setOpenSnackBar(true);
                            return;
                        }
                        openImageViewer();
                    }
                },
            },
            {
                label: "Download Img",
                icon: "pi pi-wallet",
                command: async () => {
                    if (selectionItem) {
                        for (let i = 0; i < selectionItem.length; i++) {
                            await downloadImg(selectionItem[i].trk_id, selectionItem[i].con_container);
                        }
                        setSelectionItem(null);
                    }
                },
            },
            {
                label: "Download Jpg",
                icon: "pi pi-image",
                command: async () => {
                    if (selectionItem) {
                        for (let i = 0; i < selectionItem.length; i++) {
                            await downloadJpeg(selectionItem[i].trk_id, selectionItem[i].con_container);
                        }
                        setSelectionItem(null);
                    }
                },
            },
            {
                label: "Download Tif",
                icon: "pi pi-images",
                command: async () => {
                    if (selectionItem) {
                        for (let i = 0; i < selectionItem.length; i++) {
                            await downloadTiff(selectionItem[i].trk_id, selectionItem[i].con_container);
                        }
                        setSelectionItem(null);
                    }
                },
            },
            {
                label: "Download Json",
                icon: "pi pi-ticket",
                command: async () => {
                    if (selectionItem) {
                        for (let i = 0; i < selectionItem.length; i++) {
                            await downloadJson(selectionItem[i].trk_id, selectionItem[i].con_container);
                        }
                        setSelectionItem(null);
                    }
                },
            },
            {
                label: "Laudo Técnico",
                icon: "pi pi-check-square",
                command: async () => {
                    if (selectionItem) {
                        for (let i = 0; i < selectionItem.length; i++) {
                            await downloadLaudo(selectionItem[i].trk_id, selectionItem[i].con_id);
                        }
                        setSelectionItem(null);
                    }
                },
            }


        ];


        const closeImageViewer = () => {
            setOpenImageView(false);
            setSelectionItem(null);
        };

        const openImageViewer = () => {
            setOpenSnackBar(false);
            setOpenImageView(true);
        };

        const ImageViewer = () => {
            const [imageData, setImageData] = React.useState(false);
            const [openLoadingImageViewer, setOpenLoadingImageViewer] =
                React.useState(false);

            useEffect(async () => {
                async function getImage() {
                    setOpenLoadingImageViewer(true);
                    if (typeof selectionItem[0].trk_id !== "undefined") {
                        let retImage = await containerImagewithmarks(
                            selectionItem[0].con_container,
                            selectionItem[0].trk_id
                        );
                        setImageData("data:image/jpeg;base64," + retImage.data);
                        setOpenLoadingImageViewer(false);
                    }
                }
                setOpenLoadingImageViewer(true);
                if (openImageView) {
                    await getImage();
                }
                setOpenLoadingImageViewer(false);
            }, [openImageView]);

            const headerDialog = () => {
                return (
                    <DialogTitle id="form-dialog-title">
                        <span>Visualização da Imagem do Container Truck ID</span>
                        <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>{selectionItem[0].trk_id}</span>
                        <span style={{ marginLeft: '10px' }}>Container</span>
                        <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>{selectionItem[0].con_container}</span>
                        <span style={{ marginLeft: '10px' }}>Sequence</span>
                        <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>{selectionItem[0].con_xml_seq}</span>
                        <Divider style={{ width: "100%" }} />
                    </DialogTitle>
                );
            };

            return (
                <>
                    {!imageData ? (
                        <Loading open={openLoadingImageViewer} />
                    ) : (
                        <Dialog
                            visible={openImageView}
                            header={headerDialog}
                            style={{ width: "90vw", minHeight: "700px" }}
                            modal
                            onHide={closeImageViewer}
                        >
                            <DialogContent>
                                <img
                                    src={imageData}
                                    width="100%"
                                    height="auto"
                                    alt="Imagem Container"
                                />
                            </DialogContent>
                        </Dialog>
                    )}
                </>
            );
        };

        const downloadImg = async (trk_id, con_container) => {
            setOpenLoading(true);
            try {
                const ret2 = await containerDownloadImg(trk_id);
                const file = trk_id + "S.Img";
                var blob = new Blob([ret2], { type: "application/octet-stream" });
                download(blob, file);
                setOpenLoading(false);
                severity = "success";
                msg = `Download do container ${con_container} concluído`;
                setOpenSnackBar(true);
            } catch (error) {
                severity = "error";
                msg = `Não consegui fazer o download do container ${con_container}. Verifique com suporte.`;
                setOpenSnackBar(true);
                setOpenLoading(false);
            }
        };

        const downloadXlsx = async () => {
            setOpenLoading(true);
            try {
                const xlsx = await postListarcontainerDownloadXls(
                    screenValues.operacao,
                    screenValues.veredito,
                    screenValues.dataInicial,
                    screenValues.dataFinal,
                    screenValues.conId,
                    screenValues.cliId
                );

                const file = "listar_containers.xlsx";
                download(xlsx, file);
                setOpenLoading(false);
                severity = "success";
                msg = `Download do container concluído`;
                setOpenSnackBar(true);
            } catch (error) {
                severity = "error";
                msg = `Não consegui fazer o download. Verifique com suporte. ${error}`;
                setOpenSnackBar(true);
                setOpenLoading(false);
            }
        };


        const downloadJpeg = async (trk_id, con_container) => {
            setOpenLoading(true);
            try {
                const ret2 = await containerDownloadJpeg(trk_id);
                const file = trk_id + "S.jpg";
                var blob = new Blob([ret2], { type: "application/octet-stream" });
                download(blob, file);
                setOpenLoading(false);
                severity = "success";
                msg = `Download do container ${con_container} concluído`;
                setOpenSnackBar(true);
            } catch (error) {
                severity = "error";
                msg = `Não consegui fazer o download do container ${con_container}. Verifique com suporte.`;
                setOpenSnackBar(true);
                setOpenLoading(false);
            }
        };

        const downloadLaudo = async (trk_id, con_id) => {
            setOpenLoading(true);
            try {
                const ret2 = await containerLaudo(con_id);
                const file = trk_id + ".pdf";
                var blob = new Blob([ret2], { type: "application/octet-stream" });
                download(blob, file);
                setOpenLoading(false);
                severity = "success";
                msg = `Download do laudo ${trk_id} concluído`;
                setOpenSnackBar(true);
            } catch (error) {
                severity = "error";
                msg = `Não consegui fazer o download do laudo ${trk_id}. Verifique com suporte.`;
                setOpenSnackBar(true);
                setOpenLoading(false);
            }
        };


        const downloadTiff = async (trk_id, con_container) => {
            setOpenLoading(true);
            try {
                const ret2 = await containerDownloadTiff(trk_id);
                const file = trk_id + "S.tif";
                var blob = new Blob([ret2], { type: "application/octet-stream" });
                download(blob, file);
                setOpenLoading(false);

                severity = "success";
                msg = `Download do container ${con_container} concluído`;
                setOpenSnackBar(true);
            } catch (error) {
                severity = "error";
                msg = `Não consegui fazer o download do container ${con_container}. Verifique com suporte.`;
                setOpenSnackBar(true);
                setOpenLoading(false);
            }
        };

        const downloadJson = async (trk_id, con_container) => {
            setOpenLoading(true);
            const file = "inspection.json";
            try {
                const ret2 = await containerDownloadJson(trk_id);
                var blob = new Blob([ret2], { type: "application/octet-stream" });
                download(blob, file);
                setOpenLoading(false);

                severity = "success";
                msg = `Download do container ${file} concluído`;
                setOpenSnackBar(true);
            } catch (error) {
                severity = "error";
                msg = `Não consegui fazer o download do container ${file}. Verifique com suporte.`;
                setOpenSnackBar(true);
                setOpenLoading(false);
            }
        };

        // const downloadXml = async () => {
        //     setOpenLoading(true);
        //     try {
        //         const ret2 = await containerDownloadXml(selectionItem.trk_id);
        //         const file = selectionItem.trk_id + ".xml";
        //         var blob = new Blob([ret2], { type: "application/xml" });
        //         download(blob, file);
        //         setOpenLoading(false);
        //         severity = "success";
        //         msg = `Download do container ${selectionItem.con_container} concluído`;
        //         setOpenSnackBar(true);
        //     } catch (error) {
        //         severity = "error";
        //         msg = `Não consegui fazer o download do container ${selectionItem.con_container}. Verifique com suporte.`;
        //         setOpenSnackBar(true);
        //         setOpenLoading(false);
        //     }
        // };

        const downloadXml = async (trk_id, con_container) => {
            setOpenLoading(true);
            try {
                const ret2 = await containerDownloadXml(trk_id, con_container);
                const file = trk_id + ".xml";
                var blob = new Blob([ret2], { type: "application/xml" });
                download(blob, file);
                setOpenLoading(false);
                severity = "success";
                msg = `Download do container ${con_container} concluído`;
                setOpenSnackBar(true);
            } catch (error) {
                severity = "error";
                msg = `Não consegui fazer o download do container ${con_container}. Verifique com suporte.`;
                setOpenSnackBar(true);
                setOpenLoading(false);
            }
        };


        const [listContainers, setListContainers] = React.useState([]);
        const [listCliente, setListCliente] = React.useState([]);
        const [openLoading, setOpenLoading] = React.useState(false);

        //const ExcelFile = ReactExport.ExcelFile;
        //const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        //const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        const [rowsPerPage, setRowsPerPage] = React.useState(5);
        const [totalRows, setTotalRows] = React.useState(0);
        const [page, setPage] = React.useState(0);
        const [first, setFirst] = React.useState(0);
        const [screenValues, setScreenValues] = React.useState({});

        useEffect(async () => {
            let dtif = format(
                new Date(new Date().getTime() - 1 * MS_PER_DAY),
                "yyyy-MM-dd'T'HH:mm:ss"
            );
            let dtff = format(new Date(), "yyyy-MM-dd'T'HH:mm:ss");

            const respCliente = await clienteFindAllByUsuId();
            setListCliente(respCliente.data);
            const resp = await postListarContainers(
                "Todos",
                "Todos",
                dtif,
                dtff,
                "None",
                0
            );
            setListContainers(resp.data.data);
        }, []);

        const conDataScanBodyTemplate = (rowData) => {
            if (!(rowData.con_data_scan == null)) {
                return format(new Date(rowData.con_data_scan), "dd/MM/yy-HH:mm");
            }
            return undefined;
        };

        const v1DataBodyTemplate = (rowData) => {
            if (!(rowData.v1_data == null)) {
                return format(new Date(rowData.v1_data), "dd/MM/yy-HH:mm");
            }
            return undefined;
        };

        const v2DataBodyTemplate = (rowData) => {
            if (!(rowData.v2_data == null)) {
                return format(new Date(rowData.v2_data), "dd/MM/yy-HH:mm");
            }
            return undefined;
        };
        const conAiDataBodyTemplate = (rowData) => {
            if (!(rowData.con_ai_data == null)) {
                return format(new Date(rowData.con_ai_data), "dd/MM/yy-HH:mm");
            }
            return undefined;
        };

        const v1VereditoBodyTemplate = (rowData) => {
            return (
                <CirculoVeredito
                    analise={rowData.v1_analise}
                    verId={rowData.v1_ver_id}
                    text={rowData.v1_analise}
                />
            );
        };

        const v2VereditoBodyTemplate = (rowData) => {
            return (
                <CirculoVeredito
                    analise={rowData.v2_analise}
                    verId={rowData.v2_ver_id}
                    text={rowData.v2_analise}
                />
            );
        };

        const verIdPortoBodyTemplate = (rowData) => {
            //            return <CirculoVereditoPorto veredito={rowData.ver_id_porto} />;
            return (
                <CirculoVeredito
                    analise={rowData.ver_id_porto_analise}
                    verId={rowData.ver_id_porto}
                    text={rowData.ver_id_porto_analise}
                />
            );


        };



        const conSituacaoBodyTemplate = (rowData) => {
            return <CirculoStatus status={rowData.con_situacao} />;
        };

        const conDiretorioBodyTemplate = (rowData) => {
            console.log("RowData", rowData, "selectionItem", selectionItem)
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                    }}
                >
                    <Tooltip title="Visualizar marcas" aria-label="img">
                        <IconButton onClick={openImageViewer} disabled={selectionItem ? rowData.id === selectionItem.id ? false : true : true}>
                            <DeveloperBoard />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        };


        const renderBolinha = (veredito) => {
            if (veredito === "Cheio") {
                return (
                    <Tooltip title="Cheio">
                        <div
                            style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                backgroundColor: "black",
                            }}
                        ></div>
                    </Tooltip>
                );
            } else if (veredito === "Vazio") {
                return (
                    <Tooltip title="Vazio">
                        <div
                            style={{
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                border: "1px solid black",
                                backgroundColor: "white",
                            }}
                        ></div>
                    </Tooltip>
                );
            } else {
                return <></>;
            }
        };





        const renderFooter = (
            <>
                <Paginator
                    first={first}
                    page={page}
                    rows={rowsPerPage}
                    totalRecords={totalRows}
                    rowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
                    onPageChange={async (params) => {
                        const list = await postListarContainers(
                            screenValues.operacao,
                            screenValues.veredito,
                            screenValues.dataInicial,
                            screenValues.dataFinal,
                            screenValues.conId,
                            screenValues.cliId,
                            params.page,
                            params.rows
                        );

                        setRowsPerPage(params.rows);
                        setPage(params.page);
                        setFirst(params.page * params.rows);
                        setListContainers(list.data.data);
                        setTotalRows(list.data.linhas);
                        setOpenLoading(false);
                    }}
                    template={{
                        layout:
                            "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink  RowsPerPageDropdown JumpToPageInput",
                    }}
                />
            </>
        );


        return (
            <Fragment>
                <Formik
                    initialValues={{
                        dataInicial: new Date(
                            new Date().getTime() - DIAS_LIMIT * MS_PER_DAY
                        ),
                        dataFinal: new Date(),
                        conId: undefined,
                        cliId: undefined,
                        operacao: "Todos",
                        veredito: "Todos",
                    }}
                    validate={(values) => {
                        const errors = {};
                        return errors;
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue }) => {
                        setOpenSnackBar(false);
                        const diffInDays = differenceInDays(
                            values.dataFinal,
                            values.dataInicial
                        );
                        let dtif;
                        let dtff;

                        if (values.dataInicial.getTime() > values.dataFinal.getTime()) {
                            severity = "error";
                            msg = "Data inicial maior que data final";
                            setOpenSnackBar(true);
                            console.log("DATA MAIOR");
                            return;
                        } else if (diffInDays > DIAS_LIMIT_MAX) {
                            severity = "error";
                            msg = `Ops, intervalos maiores que ${DIAS_LIMIT_MAX} dias não são permitidos`;
                            setOpenSnackBar(true);
                            return;
                        }

                        dtif = format(values.dataInicial, "yyyy-MM-dd") + "'T'00:00:00";
                        dtff = format(values.dataFinal, "yyyy-MM-dd") + "'T'23:59:59";

                        setOpenLoading(true);
                        setScreenValues({
                            operacao: values.operacao,
                            veredito: values.veredito,
                            dataInicial: dtif,
                            dataFinal: dtff,
                            conId: values.conId,
                            cliId: values.cliId,
                        });

                        const list = await postListarContainers(
                            values.operacao,
                            values.veredito,
                            dtif,
                            dtff,
                            values.conId,
                            values.cliId,
                            0,
                            rowsPerPage
                        );

                        setListContainers(list.data.data);
                        setPage(+list.data.pagina - 1);
                        setRowsPerPage(list.data.linhasPorPagina);
                        setTotalRows(list.data.linhas);
                        setOpenLoading(false);
                    }}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        isValid,
                    }) => (
                        <form
                            onSubmit={handleSubmit}
                            className={classes.form}
                            style={{ display: "flex" }}
                        >
                            <div className={classes.boxCenter}>
                                <Paper className={classes.box} elevation={7}>
                                    <ShowMessageBox
                                        open={openSnackBar}
                                        setOpen={setOpenSnackBar}
                                        severity={severity}
                                        msg={msg}
                                    />
                                    <ImageViewer />
                                    <Loading open={openLoading} />
                                    <div className={classes.dashboard_header}>
                                        {/* <div className={classes.center_data}>
                        <div>
                          <div>
                            <h2 style={{ color: "white" }}>Containers</h2>
                          </div>
                          <div>
                            <h3 style={{ color: "white" }}>
                              <HourglassEmptyIcon /> Listar Por
                            </h3>
                          </div>
                        </div>
                      </div> */}

                                        <div className={classes.dashboard_header_status}>
                                            <div className={classes.center_data}>
                                                {/* //* Dropdown operacao do container */}
                                                <FormControl className={classes.operacao}>
                                                    <InputLabel id="label-operacao">Operação</InputLabel>
                                                    <Select
                                                        labelId="label-operacao"
                                                        id="operacao"
                                                        name="operacao"
                                                        value={values.operacao}
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem key="" value="Todos">
                                                            Todos
                                                        </MenuItem>
                                                        <MenuItem key="Suspeito" value="Suspeito">
                                                            Suspeito
                                                        </MenuItem>
                                                        <MenuItem key="Aprovado" value="Aprovado">
                                                            Aprovado
                                                        </MenuItem>
                                                        <MenuItem key="Inconsistente" value="Inconsistente">
                                                            Inconsistente
                                                        </MenuItem>
                                                        <MenuItem key="Pendente" value="Pendente">
                                                            Pendente
                                                        </MenuItem>
                                                        <MenuItem key="Desativado" value="Desativado">
                                                            Desativado
                                                        </MenuItem>
                                                        <MenuItem key="Indefinido" value="Indefinido">
                                                            Indefinido
                                                        </MenuItem>
                                                        <MenuItem key="Erro" value="Erro">
                                                            Erro
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>
                                                <FormControl className={classes.veredito}>
                                                    <InputLabel id="label-operacao">
                                                        Ver. Porto
                                                    </InputLabel>
                                                    <Select
                                                        labelId="label-operacao"
                                                        id="veredito"
                                                        name="veredito"
                                                        value={values.veredito}
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem key="" value="Todos">
                                                            Todos
                                                        </MenuItem>
                                                        <MenuItem key="Suspeito" value="Suspeito">
                                                            Suspeito
                                                        </MenuItem>
                                                        <MenuItem key="Aprovado" value="Aprovado">
                                                            Aprovado
                                                        </MenuItem>
                                                    </Select>
                                                </FormControl>

                                                {/* //* TEXT FIELD */}
                                                <TextField
                                                    value={values.conId}
                                                    id="conId"
                                                    name="conId"
                                                    type="text"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    label="Container"
                                                    className={classes.container}
                                                    helperText={errors.conId}
                                                />

                                                {/* //* TEXT FIELD */}
                                                <FormControl className={classes.site}>
                                                    <InputLabel id="label-cliente">Cliente</InputLabel>
                                                    <Select
                                                        labelId="label-cliente"
                                                        id="cliId"
                                                        name="cliId"
                                                        autoWidth
                                                        value={values.cliId}
                                                        onChange={handleChange}
                                                    >
                                                        <MenuItem key="" value="0">
                                                            Nenhum...
                                                        </MenuItem>

                                                        {listCliente.map((cliente) => (
                                                            <MenuItem
                                                                key={cliente.cli_id}
                                                                value={cliente.cli_id}
                                                            >
                                                                {cliente.cli_nome}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>

                                        <div className={classes.center_data}>
                                            <div className={classes.dashboard_header_filtro}>
                                                {/* <span style={{ marginRight: "20px" }}>Período:</span> */}
                                                <MuiPickersUtilsProvider
                                                    locale={ptBR2}
                                                    utils={DateFnsUtils}
                                                >
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        format="dd/MM/yyyy"
                                                        id="dataInicial"
                                                        name="dataInicial"
                                                        value={values.dataInicial}
                                                        onChange={(val) => {
                                                            setFieldValue("dataInicial", val);
                                                            const dataFim = addDays(val, DIAS_LIMIT);
                                                            setFieldValue("dataFinal", dataFim);
                                                        }}
                                                        onBlur={handleBlur}
                                                        style={{ width: "150px", marginRight: "30px" }}
                                                        KeyboardButtonProps={{
                                                            "aria-label": "change date",
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>

                                                <MuiPickersUtilsProvider
                                                    locale={ptBR2}
                                                    utils={DateFnsUtils}
                                                >
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        format="dd/MM/yyyy"
                                                        value={values.dataFinal}
                                                        style={{ width: "150px", marginRight: "30px" }}
                                                        id="dataFinal"
                                                        name="dataFinal"
                                                        onChange={(val) => {
                                                            setFieldValue("dataFinal", val);
                                                        }}
                                                        onBlur={handleBlur}
                                                        KeyboardButtonProps={{
                                                            "aria-label": "change date",
                                                        }}
                                                    />
                                                </MuiPickersUtilsProvider>

                                                <Tooltip title="Filtrar os dados">
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        type="submit"
                                                        style={{ fontWeight: "bold" }}
                                                    >
                                                        <FilterAltIcon />
                                                    </Button>
                                                </Tooltip>

                                                <Tooltip title="Exportar para Excel">
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => {
                                                            downloadXlsx();
                                                        }}
                                                        disabled={listContainers.length === 0}
                                                        style={{ fontWeight: "bold", marginLeft: "10px" }}
                                                        Tooltip="Gerar a planilha xlsx"
                                                    >
                                                        <SaveAlt />
                                                    </Button>
                                                </Tooltip>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.boxPrancheta}>
                                        <div className={classes.boxDataGrid}>
                                            <ThemeProvider theme={theme}>
                                                <ContextMenu model={menuModel} ref={cm} />
                                                <DataTable
                                                    value={listContainers}
                                                    stripedRows
                                                    tableStyle={{
                                                        minWidth: "50rem",
                                                        maxheight: "60vh",
                                                    }}
                                                    scrollable
                                                    scrollHeight="50vh"
                                                    dataKey="con_id"
                                                    selectionMode="checkbox"
                                                    onSelectionChange={(e) => (setSelectionItem(e.value))}
                                                    selection={selectionItem}
                                                    rows={rowsPerPage}
                                                    rowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
                                                    footer={renderFooter}
                                                    onContextMenu={(e) => cm.current && cm.current.show(e.originalEvent)}
                                                    contextMenuSelection={selectionItem}
                                                >
                                                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                                                    <Column
                                                        field="con_container"
                                                        header="Container"
                                                        dataType="string"
                                                        style={{ width: "150px" }}
                                                    />
                                                    <Column
                                                        field="con_placa_vehicle"
                                                        header="Placa Veículo"
                                                        dataType="string"
                                                        style={{ width: "150px" }}
                                                    />
                                                    <Column
                                                        field="con_placa_trailer"
                                                        header="Placa Carreta"
                                                        dataType="string"
                                                        style={{ width: "200px" }}
                                                    />


                                                    <Column
                                                        field="cli_nome"
                                                        header="Cliente"
                                                        dataType="string"
                                                        style={{ width: "170px" }}
                                                    />
                                                    <Column
                                                        field="sit_nome"
                                                        header="Site Nome"
                                                        dataType="string"
                                                        style={{ width: "170px" }}
                                                    />
                                                    <Column
                                                        field="sit_id"
                                                        header="Site Id"
                                                        dataType="string"
                                                        style={{ width: "170px" }}
                                                    />
                                                    <Column
                                                        field="con_situacao"
                                                        header="Status Final"
                                                        style={{ width: "170px" }}
                                                        body={conSituacaoBodyTemplate}
                                                    />
                                                    <Column
                                                        field="con_data_scan"
                                                        header="Data Scan"
                                                        style={{ width: "170px" }}
                                                        body={conDataScanBodyTemplate}
                                                    />

                                                    <Column
                                                        field="ver_id_porto"
                                                        header="Status 1° Analise"
                                                        style={{ width: "170px" }}
                                                        body={verIdPortoBodyTemplate}
                                                    />
                                                    <Column
                                                        field="v1_data"
                                                        header="Data 2° Analise"
                                                        style={{ width: "160px" }}
                                                        body={v1DataBodyTemplate}
                                                    />

                                                    <Column
                                                        field="v1_data"
                                                        header="Data 2° Analise"
                                                        style={{ width: "160px" }}
                                                        body={v1DataBodyTemplate}
                                                    />
                                                    <Column
                                                        field="v1_veredito"
                                                        header="Status 2° Analise"
                                                        style={{ width: "140px" }}
                                                        body={v1VereditoBodyTemplate}
                                                    />
                                                    <Column
                                                        field="v2_data"
                                                        header="Data 3° Analise"
                                                        style={{ width: "160px" }}
                                                        body={v2DataBodyTemplate}
                                                    />

                                                    <Column
                                                        field="v2_veredito"
                                                        header="Status 3° Analise"
                                                        style={{ width: "140px" }}
                                                        body={v2VereditoBodyTemplate}
                                                    />
                                                    <Column
                                                        field="ia_analise"
                                                        header="Veredito IA"
                                                        style={{ width: "150px" }}
                                                        body={(rowData) =>
                                                            renderBolinha(rowData.ia_analise)
                                                        }
                                                    />
                                                    <Column
                                                        field="con_ai_data"
                                                        header="Data IA"
                                                        style={{ width: "160px" }}
                                                        body={conAiDataBodyTemplate}
                                                    />
                                                    <Column
                                                        field="tipo"
                                                        header="Tipo"
                                                        style={{ width: "120px" }}
                                                    />
                                                </DataTable>
                                            </ThemeProvider>
                                        </div>
                                    </div>
                                </Paper>
                            </div>
                        </form>
                    )}
                </Formik>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Pagina
                authState={authState}
                Content={Content}
                HeaderDesc="LISTAR CONTAINERS"
            />
        </Fragment>
    );
}
